<twc-badge class="status-label width-100" [type]="getStatusBadgeType()" [ngClass]="getStatusBadgeClass()">
    {{'JOBS.' + status.toString()| translate}}
</twc-badge>